import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AgAuthenticationService } from '@ag/vc.ag-core/authentication';

type Options = {
  headers?: HttpHeaders | {
      [header: string]: string | string[];
  };
  context?: HttpContext;
  observe?: 'body';
  params?: HttpParams | {
      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FactoryhelperService {

  constructor(private http: HttpClient, private readonly authenticationService: AgAuthenticationService) { }

  get<T>(url: string, options?: Options): Observable<T> {
    if (options) { return this.http.get<T>(url, options); }
    return this.http.get<T>(url);
  }

  post<T>(url: string, data: unknown, options?: Options): Observable<T> {
    if (options) { return this.http.post<T>(url, data, options); }
    return this.http.post<T>(url, data);
  }

  put<T>(url: string, data: unknown, options?: Options): Observable<T> {
    if (options) { return this.http.put<T>(url, data, options); }
    return this.http.put<T>(url, data);
  }

  patch<T>(url: string, data: unknown, options?: Options): Observable<T> {
    if (options) { return this.http.patch<T>(url, data, options); }
    return this.http.patch<T>(url, data);
  }

  delete(url: string) {
    return this.http.delete(url);
  }

}
